module.exports = __webpack_public_path__ + "static/media/marchio_osa_dark.e431ed7c.png";